import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import "./index.scss";
import { useWindowSize } from "../../../../hooks/use-device-type";

export interface SvgCompPracticeProps {}

export function SvgCompPractice(props: SvgCompPracticeProps) {
  const { isMobile } = useWindowSize();
  const placement = isMobile ? "top" : "right-start";
  return (
    <OverlayTrigger
      placement={placement}
      // show={true}
      overlay={
        <Popover id="svg-comp-practice">
          <Popover.Body>
            <h3>核心：定制培训和定向培养</h3>

            <ul>
              <li>前期以区域产业发展方向定制培训技能；</li>
              <li>中期以产业发展需求定向培养人才；</li>
              <li>后期提升区域人才队伍适用市场环境。</li>
            </ul>
          </Popover.Body>
        </Popover>
      }
    >
      <g className="svg-comp-piece">
        <path
          fill="#0070bf"
          d="M382.5 31.5c21.07 9.033 40.403 20.866 58 35.5 59.298 51.096 91.631 115.929 97 194.5 8.336.389 16.669.889 25 1.5a12399.949 12399.949 0 0 1-89.5 54.5 3965.145 3965.145 0 0 1-86.5-56.5 162.597 162.597 0 0 1 18-.5c-7.048-53.547-35.048-91.713-84-114.5a889.526 889.526 0 0 1 62-30.5v-84Z"
          style={{
            opacity: 0.989
          }}
        />

        <text x={420} y={210} fontSize={60} fill="#fff" fontWeight={"bold"}>
          培
        </text>
      </g>
    </OverlayTrigger>
  );
}
